<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="pt-0">
    <v-row class="pt-0">
      <v-col cols="12">
        <div class="primary--text text-h6 text-md-h5 font-weight-medium">
          {{ $t('title_txt_set_page') }}
        </div>
      </v-col>
      <v-col cols="12" md="8" class="pt-0" order="2" order-md="1">
        <v-row>
          <v-col cols="12">
            <v-card-subtitle>
              <v-icon class="red--text">mdi-information-variant</v-icon>
              {{ $t('cap_welcome_mss') }}
            </v-card-subtitle>
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    disable-icon-rotate
                    @click="initialize"
                  >
                    {{ $t('cap_branch') }}
                    <template v-slot:actions>
                      <v-icon
                        v-if="
                          $store.getters['tenant/activeBranches'].length < 1
                        "
                        color="error"
                      >
                        mdi-alert-circle
                      </v-icon>
                      <v-icon v-else color="teal"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        color="blue"
                        v-bind="attrs"
                        @click="initialize"
                        v-on="on"
                      >
                        <h5>{{ $t('cap_form_create_category') }}</h5>
                      </v-btn>
                    </template>
                    <v-card>
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="Branch"
                          class="elevation-1"
                        >
                          <template v-slot:item.active="{ item }">
                            <v-simple-checkbox
                              v-model="item.active"
                              color="green"
                              @click="activeBranch"
                            ></v-simple-checkbox>
                          </template>
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title
                                v-html="
                                  $t('cap_txt_bus_branch', {
                                    value:
                                      $store.getters['tenant/activeBranches']
                                        .length
                                  })
                                "
                              ></v-toolbar-title>
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-spacer></v-spacer>
                              <v-dialog v-model="dialog1" max-width="400px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    dark
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t('cap_new_branch') }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-card-text>
                                    <v-form
                                      ref="formName"
                                      v-model="valid"
                                      lazy-validation
                                    >
                                      <v-container>
                                        <v-row>
                                          <v-col cols="12" sm="12" md="12">
                                            <v-text-field
                                              v-model="editedItem.name"
                                              label="name"
                                              :rules="nameRules"
                                              :counter="20"
                                              required
                                              outlined
                                            ></v-text-field>
                                          </v-col>
                                          <!--                                            <v-col cols="6" sm="6" md="6">-->
                                          <!--                                              <v-switch-->
                                          <!--                                                v-model="editedItem.active"-->
                                          <!--                                              ></v-switch>-->
                                          <!--                                            </v-col>-->
                                        </v-row>
                                      </v-container>
                                    </v-form>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="close"
                                    >
                                      {{ $t('btn_txt_cancel') }}
                                    </v-btn>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="save"
                                    >
                                      {{ $t('btn_cap_save') }}
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                              <v-dialog
                                v-model="dialogDelete"
                                max-width="580px"
                              >
                                <v-card>
                                  <v-card-title class="text-lg-h6"
                                    >{{ $t('cap_delete_branch') }} "
                                    {{ itemName }} " ?
                                  </v-card-title>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="closeDelete"
                                      >{{ $t('btn_txt_cancel') }}</v-btn
                                    >
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="deleteItemConfirm"
                                      >{{ $t('btn_txt_accept') }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                              mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteItem(item)">
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </template>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header @click="toPayment">
                    {{ $t('cap_paymentmethod') }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <CassNewPaymentMenthod
                      :payment-methods="paymentMethods"
                    ></CassNewPaymentMenthod>
                    <CassPaymentView
                      :locale="locale"
                      :payment-methods="paymentMethods"
                    ></CassPaymentView>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header @click="toVat">
                    {{ $t('cap_txt_vad') }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-form ref="Vatt" v-model="Vat" lazy-validation>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="3">
                            <v-text-field
                              v-model="vat"
                              type="number"
                              :label="$t('input_txt_vat')"
                              prefix="%"
                            ></v-text-field>
                          </v-col>
                          <v-icon v-show="checkVat" class="primary--text"
                            >mdi-check</v-icon
                          >
                          <v-col>
                            <v-btn color="blue darken-1" text @click="enterVat">
                              {{ $t('btn_cap_save') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header @click="welcometxt">
                    {{ $t('cap_txt_welcome_mss') }}
                    <template v-slot:actions>
                      <!--                        <v-icon color="error">-->
                      <!--                          mdi-alert-circle-->
                      <!--                        </v-icon>-->
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!--                          <v-card-subtitle v-show="afterWelTxt">-->
                    <!--                            <v-icon class="primary&#45;&#45;text"-->
                    <!--                            >mdi-information-variant</v-icon-->
                    <!--                            >-->
                    <!--                            {{ $t('cap_welcome_mss') }}-->
                    <!--                          </v-card-subtitle>-->
                    <v-form ref="capAdd">
                      <v-textarea
                        v-model="welcomemss.text"
                        :placeholder="$t('cap_form_create_prod_wel')"
                        auto-grow
                        outlined
                      ></v-textarea>
                      <v-btn
                        color="primary"
                        class="white--text"
                        @click="submitWelTxt"
                      >
                        {{ $t('btn_cap_save') }}
                      </v-btn>
                      <v-icon v-show="completedwelcome" class="primary--text"
                        >mdi-check</v-icon
                      >
                    </v-form>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <span class="primary--text text-capitalize">
                  {{ $t('title_txt_fbpage') }}
                </span>
              </v-card-title>
              <v-card-text class="px-12">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-avatar size="40" class="mr-2">
                      <v-icon class="blue--text">mdi-facebook</v-icon>
                    </v-avatar>
                    <span class="align-self-center text--primary">
                      {{ $t('cap_txt_fbpage_sub') }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="ml-11 ml-md-12">
                    <v-row>
                      <v-col
                        v-if="$store.state.tenant.linkedFacebookPage"
                        cols="12"
                      >
                        <div>
                          {{ $t('cap_msg_fbpage_current') }}
                          <span class="primary--text">
                            {{
                              $store.state.tenant.linkedFacebookPage
                                .facebookPageName
                            }}
                            ({{
                              $store.state.tenant.linkedFacebookPage
                                .facebookPageId
                            }})
                          </span>
                        </div>
                      </v-col>
                      <v-col v-if="!linkFb.success" cols="12">
                        <v-btn
                          color="primary"
                          class="white--text"
                          :loading="linkFb.loading"
                          :disabled="linkFb.loading"
                          @click="onLinkFacebookClick"
                        >
                          <v-icon dark>mdi-facebook</v-icon>
                          {{ $t('btn_msg_fbpage_link') }}
                        </v-btn>
                      </v-col>
                      <v-col v-if="linkFb.error" cols="12">
                        <div class="error--text">
                          <v-icon>mdi-warning</v-icon> {{ linkFb.error }}
                        </div>
                      </v-col>
                      <v-col v-if="linkFb.success" cols="12">
                        <div>
                          {{ $t('cap_msg_fbpage_choose') }}
                        </div>
                        <div>
                          <v-radio-group v-model="linkFb.chosenPage">
                            <v-radio
                              v-for="page in linkFb.pages"
                              :key="page.id"
                              :label="`${page.name} (${page.id})`"
                              :value="page"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                        <div>
                          <v-btn
                            :loading="linkFb.confirmedLoading"
                            :disabled="linkFb.confirmedLoading"
                            class="primary"
                            @click="onConfirmedLinkFacebookClick"
                          >
                            {{ $t('btn_msg_fbpage_choose_confirm') }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="pt-0" order="1" order-md="2">
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title class="primary--text">
                {{ $t('title_txt_profile') }}
              </v-card-title>
              <v-card-text>
                <span class="d-flex pa-3">
                  <v-avatar size="70" class="mr-3" color="primary">
                    <span class="white--text headline">
                      {{ $store.getters['account/name'].charAt(0) }}
                    </span>
                  </v-avatar>
                  <span class="primary--text align-self-center">
                    <div class="font-weight-bold">{{ name }}</div>
                    <div>{{ phone }}</div>
                  </span>
                </span>
              </v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation class="px-7">
                <v-text-field
                  v-model="name"
                  disabled
                  outlined
                  :rules="nameRule"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="phone"
                  outlined
                  disabled
                  :rules="phoneNumRule"
                  required
                ></v-text-field>
                <!--TODO: Allow Up Name in the Future-->
                <v-card-actions>
                  <v-row no-gutters>
                    <v-col>
                      <v-btn text color="primary" @click="businessHourSet">{{
                        $t('btn_setting_edit_business')
                      }}</v-btn>
                    </v-col>
                    <v-col>
                      <v-btn text color="primary" @click="editLang">{{
                        $t('btn_setting_edit_lang')
                      }}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-form>
              <!--              <v-card-actions>-->
              <!--                <v-spacer></v-spacer>-->
              <!--                <v-btn @click="onSave">save</v-btn>-->
              <!--              </v-card-actions>-->
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!--      <v-dialog v-model="dialog" persistent max-width="300">-->
      <!--        <v-card>-->
      <!--          <v-card-text class="red&#45;&#45;text pt-4 pb-0">Are you sure you want to change your name?</v-card-text>-->
      <!--          <v-card-actions>-->
      <!--            <v-btn color="primary" text @click="onCancel">Cancel</v-btn>-->
      <!--            <v-spacer></v-spacer>-->
      <!--            <v-btn color="primary" text @click="onSubmit">Yes</v-btn>-->
      <!--          </v-card-actions>-->
      <!--        </v-card>-->
      <!--      </v-dialog>-->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">{{
            $t('cap_txt_business_title')
          }}</v-card-title>
          <v-card-text>
            <v-form ref="addTime">
              <v-row>
                <v-col cols="4" class="pr-0 pl-1 py-4">
                  <v-card-text class="font-weight-bold">{{
                    $t('cap_Timezone')
                  }}</v-card-text>
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="TimeZone"
                    :items="timezones"
                  ></v-autocomplete>
                </v-col>
                <!--                <v-col cols="8" class="pr-0">-->
                <!--                  <v-checkbox-->
                <!--                    class="font-weight-bold"-->
                <!--                    :label="$t('btn_always_open')"-->
                <!--                    @click.native="alwaysOpen()"-->
                <!--                  >-->
                <!--                  </v-checkbox>-->
                <!--                </v-col>-->
                <v-container fluid>
                  <!--                  <p class="font-weight-bold">{{ radios || 'null' }}</p>-->
                  <v-radio-group v-model="radios" mandatory>
                    <v-radio
                      :label="$t('btn_custom_hour')"
                      value="Custom Hour"
                      @click.native="customHour"
                    ></v-radio>
                    <v-radio
                      :label="$t('btn_always_open')"
                      value="Always Open"
                      @click.native="alwaysOpen()"
                    ></v-radio>
                  </v-radio-group>
                </v-container>
              </v-row>
              <p v-show="clock" class="caption red--text">
                {{ $t('cap_validate_clock') }}
              </p>
              <v-divider></v-divider>
              <v-row
                v-for="(date, i) in businessHourSets"
                :key="i"
                class="pl-0"
              >
                <v-col cols="4" class="pl-5 pr-0 py-5">
                  <span class="pb-auto pl-auto font-weight-bold">{{
                    checkDate(date.day)
                  }}</span>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-autocomplete
                    v-model="date.start"
                    :items="hours"
                    :label="$t('cap_opening')"
                    :disabled="disable"
                    :rules="startTimeRule"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-autocomplete
                    v-model="date.end"
                    :items="hours"
                    :label="$t('cap_closing')"
                    :disabled="disable"
                    :rules="endTimeRule"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="onCancelBusinessTime">
              {{ $t('btn_txt_cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="startTimeRule" color="primary" @click="workSave">
              {{ $t('btn_txt_accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLang" max-width="500">
        <v-card>
          <v-card-title class="text-h5">{{
            $t('title_form_language')
          }}</v-card-title>
          <v-card-text>
            <div>
              <span v-if="errorLang" class="caption error--text">{{
                $t('cap_msg_en_required')
              }}</span>
            </div>
            <v-form ref="setLang">
              <v-row justify="center" align="center">
                <v-col>
                  <v-autocomplete
                    v-model="lang"
                    :rules="rules.required"
                    :items="locales"
                    item-text="title"
                    item-value="locale"
                    filled
                    chips
                    :hint="$t('title_cap_language')"
                    multiple
                    outlined
                    persistent-hint
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="onRemoveLanguage(data.item.locale)"
                      >
                        {{ data.item.title }} - {{ data.item.locale }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content
                          v-text="data.item"
                        ></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="onCancel">
              {{ $t('btn_txt_cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="langSave">
              {{ $t('btn_txt_accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment-timezone'
import CassNewPaymentMenthod from '../components/dialogs/CassNewPaymentMenthod'
import CassPaymentView from '../components/cards/CassPaymentView'

export default {
  components: { CassPaymentView, CassNewPaymentMenthod },
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      radios: null,
      formName: this.$store.state.account.profile.name,
      formPhone: this.$store.state.account.profile.phone,
      valid: true,
      dialog: false,
      timeZone: 'Asia/Phnom_Penh',
      businessHours: [],
      linkFb: {
        loading: false,
        confirmedLoading: false,
        error: null,
        success: false,
        pages: [],
        result: null,
        chosenPage: {}
      },
      locales: [
        { locale: 'en', title: 'English' },
        { locale: 'km', title: 'ភាសាខ្មែរ' },
        { locale: 'zh', title: '中文' }
      ],
      dialogLang: false,
      rules: {
        required: [
          (v) =>
            Array.isArray(v)
              ? !!v && v.length > 0
              : !!v || this.$t('cap_msg_required')
        ]
      },
      lang: ['en'],
      errorLang: null,
      disabled: 0,
      disable: false,
      isequal: false,
      clock: false,
      businessHourSets: [],
      TimeZone: '',
      alwaysActive: false,
      vat: '',
      Vat: false,
      dialogvat: false,
      nameRules: [
        (v) => !!v || 'Text is required',
        (v) => v.length <= 20 || 'Text must be less than 20 characters'
      ],
      // vatRule:[
      //   v => !!v || 'Tax is required'
      // ],
      Branch: [],
      dialog1: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
          sortable: false
        },
        { text: 'Active', value: 'active', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        active: ''
      },
      defaultItem: {
        name: '',
        active: ''
      },
      itemName: '',
      welcomeTxt: '',
      paymentMethods: [],
      enterwelcomeTxt: '',
      dialogBranch: false,
      checkVat: false,
      welcomemss: {},
      completedwelcome: false
    }
  },
  computed: {
    info_notifi() {
      return [
        { text: this.$t('cap_txt_noti_msg_01') },
        { text: this.$t('cap_txt_noti_msg_02') }
      ]
    },
    name() {
      return this.$store.state.account.profile.name
    },
    phone() {
      return this.$store.state.account.profile.phone
    },
    nameRule() {
      return [
        (v) => !!v || this.$t('cap_msg_setting_form_err_001'),
        (v) => {
          const pattern = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/
          return pattern.test(v) || this.$t('cap_msg_setting_form_err_002')
        }
      ]
    },
    phoneNumRule() {
      return [
        (v) => !!v || this.$t('cap_msg_setting_form_err_003'),
        (v) => {
          const pattern = /^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
          return pattern.test(v) || this.$t('cap_msg_setting_form_err_004')
        }
      ]
    },
    endTimeRule() {
      return [(v) => !!v || 'Clock is required']
    },
    startTimeRule() {
      return [(v) => !!v || 'Clock is required']
    },
    hours() {
      const items = []
      for (let hour = 0; hour < 24; hour++) {
        items.push(('0' + hour).slice(-2) + ':00')
        items.push(('0' + hour).slice(-2) + ':10')
        items.push(('0' + hour).slice(-2) + ':15')
        items.push(('0' + hour).slice(-2) + ':20')
        items.push(('0' + hour).slice(-2) + ':25')
        items.push(('0' + hour).slice(-2) + ':30')
        items.push(('0' + hour).slice(-2) + ':35')
        items.push(('0' + hour).slice(-2) + ':40')
        items.push(('0' + hour).slice(-2) + ':45')
        items.push(('0' + hour).slice(-2) + ':50')
        items.push(('0' + hour).slice(-2) + ':55')
        items.push(('0' + hour).slice(-2) + ':59')
      }
      items.push('24:00')
      return items
    },
    timezones() {
      return moment.tz.names()
    },
    week() {
      return [
        { text: this.$t('day1'), value: 'Monday' },
        { text: this.$t('day2'), value: 'Tuesday' },
        { text: this.$t('day3'), value: 'Wednesday' },
        { text: this.$t('day4'), value: 'Thursday' },
        { text: this.$t('day5'), value: 'Friday' },
        { text: this.$t('day6'), value: 'Saturday' },
        { text: this.$t('day7'), value: 'Sunday' }
      ]
    }
  },
  watch: {
    dialog1(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    }
  },
  methods: {
    onConfirmedLinkFacebookClick() {
      this.linkFb.error = null
      this.linkFb.confirmedLoading = true
      const payload = {
        shortLivedUserAccessToken: this.linkFb.result.credential.accessToken,
        fbUserId: this.linkFb.result.additionalUserInfo.profile.id,
        pageId: this.linkFb.chosenPage.id
      }
      return this.$store
        .dispatch('account/subscribeFacebookPageToChatbot', payload)
        .then((res) => {
          // eslint-disable-next-line
          console.log(res)
          this.linkFb.success = false
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.error(err.message)
          this.linkFb.error = err
        })
        .finally(() => {
          this.linkFb.confirmedLoading = false
        })
    },
    onLinkFacebookClick() {
      this.linkFb.loading = true
      this.linkFb.success = false
      this.linkFb.pages = []
      this.linkFb.error = null
      this.linkFb.result = null
      return this.$store
        .dispatch('account/linkFacebook')
        .then((res) => {
          // eslint-disable-next-line
          console.log('result', res)
          this.linkFb.result = res
          return this.$store
            .dispatch('account/listFacebookPages', res)
            .then((data) => {
              this.linkFb.success = true
              this.linkFb.pages = data.data
              this.linkFb.chosenPage = this.linkFb.pages[0]
            })
            .catch((error) => {
              this.linkFb.error = error
            })
        })
        .catch((error) => {
          this.linkFb.error = error
        })
        .finally(() => {
          // console.log()
          this.linkFb.loading = false
        })
    },
    // disableItem(item) {
    //   console.log('item', item)
    //   return item === '00:00'
    // },
    // onSave() {
    //   if (this.$refs.form.validate()) {
    //     this.dialog = true
    //   }
    // },
    onCancel() {
      this.dialog = false
      this.dialogLang = false
      this.errorLang = null
      this.$refs.setLang.resetValidation()
    },
    onCancelBusinessTime() {
      this.dialog = false
      this.businessHourSets = []
      this.TimeZone = ''
      this.$refs.addTime.resetValidation()
      // console.log(this.businessHourSets)
    },
    // onSubmit () {
    //   this.$store.dispatch('account/updateProfile', this.formName)
    //     .then()
    //     .catch()
    //     .finally(() => {
    //       this.dialog = false
    //     })
    // },
    workSave() {
      let day = []
      let flag = true
      for (day = 0; day < 7; day++) {
        const startTime = new Date().setHours(
          this.GetHours(this.businessHourSets[day].start),
          this.GetMinutes(this.businessHourSets[day].start),
          0
        )
        const endTime = new Date().setHours(
          this.GetHours(this.businessHourSets[day].end),
          this.GetMinutes(this.businessHourSets[day].end),
          0
        )
        if (startTime >= endTime) {
          flag = false
          this.clock = true
        }
      }
      if (flag === true) {
        const workingHour = {
          newBusHour: this.businessHourSets,
          timeZone: this.TimeZone
        }
        this.clock = false
        this.$store
          .dispatch('tenant/setBusinessHour', workingHour)
          .then(() => {
            // eslint-disable-next-line
            console.log('success')
          })
          .catch(() => {
            // eslint-disable-next-line
            console.log('false')
          })
        this.dialog = false
      }
    },
    langSave() {
      if (this.$refs.setLang.validate()) {
        if (!this.lang.includes('en')) {
          this.errorLang = true
        } else {
          const lang = JSON.parse(JSON.stringify(this.$store.state.tenant.lang))
          if (this.lang.sort().join(',') !== lang.sort().join(',')) {
            this.$store
              .dispatch('tenant/setLanguage', this.lang)
              .then(() => {
                this.onCancel()
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.log('error', error)
              })
          } else {
            // eslint-disable-next-line
            console.log('no Update')
            this.onCancel()
          }
        }
      }
    },
    onRemoveLanguage(item) {
      const index = this.lang.indexOf(item)
      if (index >= 0) {
        this.lang.splice(index, 1)
      }
    },
    editLang() {
      this.lang = JSON.parse(JSON.stringify(this.$store.state.tenant.lang))
      this.dialogLang = true
    },
    alwaysOpen() {
      this.disable = true
      this.clock = false
      let day = []
      for (day = 0; day < 7; day++) {
        this.businessHourSets[day].start = '00:00'
        this.businessHourSets[day].end = '24:00'
      }
    },
    customHour() {
      this.disable = false
    },
    GetHours(d) {
      let h = parseInt(d.split(':')[0])
      if (d.split(':')[1].split(' ')[1]) {
        h = h + 12
      }
      return h
    },
    GetMinutes(d) {
      return parseInt(d.split(':')[1].split(' ')[0])
    },
    checkDate(day) {
      const date = {
        Monday: this.$t('day1'),
        Tuesday: this.$t('day2'),
        Wednesday: this.$t('day3'),
        Thursday: this.$t('day4'),
        Friday: this.$t('day5'),
        Saturday: this.$t('day6'),
        Sunday: this.$t('day7')
      }
      return date[day]
    },
    businessHourSet() {
      const WeekStart = [
        this.$store.state.tenant.businessHours[0].start,
        this.$store.state.tenant.businessHours[1].start,
        this.$store.state.tenant.businessHours[2].start,
        this.$store.state.tenant.businessHours[3].start,
        this.$store.state.tenant.businessHours[4].start,
        this.$store.state.tenant.businessHours[5].start,
        this.$store.state.tenant.businessHours[6].start
      ]
      const WeekEnd = [
        this.$store.state.tenant.businessHours[0].end,
        this.$store.state.tenant.businessHours[1].end,
        this.$store.state.tenant.businessHours[2].end,
        this.$store.state.tenant.businessHours[3].end,
        this.$store.state.tenant.businessHours[4].end,
        this.$store.state.tenant.businessHours[5].end,
        this.$store.state.tenant.businessHours[6].end
      ]
      const resultS = WeekStart.filter((word) => word === '00:00')
      const resultE = WeekEnd.filter((word) => word === '24:00')
      this.dialog = true
      this.businessHourSets = JSON.parse(
        JSON.stringify(this.$store.state.tenant.businessHours)
      )
      this.TimeZone = this.$store.state.tenant.timeZone
      this.alwaysActive = !(resultS.length === 7 && resultE.length === 7)
      if (this.alwaysActive === true) {
        this.radios = 'Custom Hour'
        this.disable = false
      } else {
        this.radios = 'Always Open'
        this.disable = true
      }
    },
    toPayment() {
      this.paymentMethods = this.$store.state.tenant.paymentMethods
    },
    initialize() {
      this.dialogBranch = true
      this.Branch = this.$store.state.tenant.branches
    },
    toVat() {
      this.vat = this.$store.state.tenant.vat
    },
    enterVat() {
      if (this.$refs.Vatt.validate() && this.vat) {
        this.dialogvat = false
        this.vat = parseInt(this.vat)
        this.$store
          .dispatch('tenant/UpdateVAT', this.vat)
          .then(() => {
            this.checkVat = true
          })
          .catch((error) => {
            this.error = error
          })
      }
    },
    editItem(item) {
      this.editedIndex = this.Branch.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog1 = true
    },
    deleteItem(item) {
      this.editedIndex = this.Branch.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
      this.itemName = item.name
    },
    deleteItemConfirm() {
      this.Branch.splice(this.editedIndex, 1)
      this.closeDelete()
      this.$store
        .dispatch('tenant/updateBranch', this.Branch)
        .then(() => {})
        .catch((error) => {
          this.error = error
        })
    },
    close() {
      this.dialog1 = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.$refs.formName.resetValidation()
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save() {
      // this.editedItem.name = this.editedItem.name.trim()
      this.editedItem.name = this.editedItem.name.trim()
      this.$refs.formName.resetValidation()
      if (this.$refs.formName.validate() && this.editedItem.name) {
        if (this.editedIndex > -1) {
          Object.assign(this.Branch[this.editedIndex], this.editedItem)
        } else {
          this.Branch.push(this.editedItem)
        }
        this.editedItem.active = true
        this.$store
          .dispatch('tenant/updateBranch', this.Branch)
          .then(() => {})
          .catch((error) => {
            this.error = error
          })
        this.close()
      }
    },
    activeBranch() {
      this.$store
        .dispatch('tenant/updateBranch', this.Branch)
        .then(() => {})
        .catch((error) => {
          this.error = error
        })
    },
    welcometxt() {
      this.enterwelcomeTxt = this.$store.state.tenant.messages.introduce
      this.welcomemss = JSON.parse(this.enterwelcomeTxt)
    },
    submitWelTxt() {
      this.welcomemss.text = this.welcomemss.text.trim()
      if (this.$refs.capAdd.validate() && this.welcomemss.text) {
        const toJson = JSON.stringify(this.welcomemss)
        this.$store
          .dispatch('tenant/updateWelMss', toJson)
          .then(() => {
            this.completedwelcome = true
          })
          .catch((error) => {
            this.error = error
          })
      }
    }
  }
}
</script>
